import { CloseOutlined } from '@ant-design/icons'
import Steps from 'app/components/Core/MachineGroup/MachineInteraction/Steps'
import KDrawer from 'app/components/Modules/Feedback/KDrawer'
import KHelp from 'app/components/Modules/KHelp'
import { RecordType } from 'app/constants/GlobalTypes'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { useRestriction } from 'app/lib/hooks/useRestriction'
import useSetBackHistory from 'app/lib/hooks/useSetBackHistory'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const portalId = 'machine-interaction-footer'

const MachineInteraction: React.FC<PageProps> = (props) => {
  const { title: pageTitle } = useTitle(props)
  const { rental_id } = useParams<{ rental_id: string }>()
  const { restricted } = useRestriction({ allowFor: ['admin', 'manager', 'member', 'accounting'] })
  const [title, setTitle] = useState<string>(pageTitle)
  const [subtitle, setSubtitle] = useState<string>(null)
  const { setBackRoute, goBack } = useBrowserRouterContext()

  useSetBackHistory(() => setBackRoute(Routes.Rental.member(rental_id).show))

  return (
    <KDrawer
      open
      subtitle={subtitle}
      width={600}
      title={title || pageTitle}
      onClose={goBack}
      footer={<div id={portalId}></div>}
      closable={!restricted}
      closeIcon={!restricted && <CloseOutlined />}
      titleExtra={
        <KHelp
          recordType={RecordType.machine_group}
          id="machine_interaction"
          popover
          popoverProps={{ placement: 'bottom', className: 'px-1' }}
        />
      }>
      <Steps
        rental_id={rental_id}
        portalId={portalId}
        setTitle={setTitle}
        setSubtitle={setSubtitle}
      />
    </KDrawer>
  )
}

export default MachineInteraction
